
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 340 255","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M311 226h-11v-38h11v38zm0-159h-11V29h11v38zM40 226H29v-38h11v38zM25 67H0v121h25v42h290v-42h25v67H0V0h340v67h-25V25H25v42zm15 0H29V29h11v38z","fill":"#9D9D9D"}}),_c('path',{attrs:{"d":"M311 186h-11v-57h11v57zm0-117v58h-11V69h11zM40 186H29v-57h11v57zm0-117v58H29V69h11zm256 133v11H44v-11h252zm0-149H44V42h252v11z","fill":"#7000BD"}})])])
          )
        }
      }
    